import { Component, ElementRef, ViewChild } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Geolocation } from '@ionic-native/geolocation';
import { HttpProvider } from '../../providers/http/http';

/**
 * Generated class for the MapaPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
 declare var google: any
@Component({
  selector: 'page-mapa',
  templateUrl: 'mapa.html',
})
export class MapaPage {
  @ViewChild('map') mapRef: ElementRef
  lat: any
  lng: any
  info: any
  police: Boolean = false
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public http : HttpProvider,
    private geolocation: Geolocation
  ) {
  }

  ionViewDidLoad() {
    this.info = null
    this.showMap()
  }

  closeModal() {
    this.viewCtrl.dismiss();
  }

  async obtenerUbi(code) {
    return await new Promise(async (resolve) =>{
      try {
        this.http.get('ubicacionClientes/codigo/'+code).subscribe(
          (res:any)=>{
            this.info.campo1 = parseFloat(res.latitud)
            this.info.campo2 = parseFloat(res.longitud)
            resolve(this.info)
          }, err=>{
            console.log(err)
            resolve(err)
          }
        )
      } catch (error) {
        console.log(error)
        resolve(error)
      }
    })
  }

  async showMap() {

    const { Map } = await google.maps.importLibrary("maps");

    let options = {
      enableHighAccuracy: true
    }
    this.info = this.navParams.get('value')
    if (this.info) {
      if (!this.info.campo1 || !this.info.campo2) await this.obtenerUbi(this.info.co_cli.trim())
    }
    if (this.info && this.info.campo1 && this.info.campo2) {
      this.lat = parseFloat(this.info.campo1)
      this.lng = parseFloat(this.info.campo2)
      let map = new Map(document.getElementById("map"), {
        center: { lat: this.lat, lng: this.lng },
        zoom: 13,
        disableDefaultUI: true,
        fullscreenControl:false
      });
      let marker = new google.maps.Marker({
        position: { lat: this.lat, lng: this.lng },
        map: map,
        draggable: true
      });
      marker.addListener('dragend', () => {
        this.lat = marker.getPosition().lat()
        this.lng = marker.getPosition().lng()
      });
    } else {
      this.police = true;
      this.geolocation.getCurrentPosition(options).then((resp) => {
        this.lat = resp.coords.latitude
        this.lng = resp.coords.longitude
        let map = new Map(document.getElementById("map"), {
          center: { lat: this.lat, lng: this.lng },
          zoom: 13,
          disableDefaultUI: true,
          fullscreenControl:false
        });
        let marker = new google.maps.Marker({
          position: { lat: this.lat, lng: this.lng },
          map: map,
          draggable: true
        });
        marker.addListener('dragend', () => {
          this.lat = marker.getPosition().lat()
          this.lng = marker.getPosition().lng()
        });
      }).catch(err => {
        this.lat = 10.0647
        this.lng = -69.3583
        let map = new Map(document.getElementById("map"), {
          center: { lat: this.lat, lng: this.lng },
          zoom: 13,
          disableDefaultUI: true,
          fullscreenControl:false
        });
        let marker = new google.maps.Marker({
          position: { lat: this.lat, lng: this.lng },
          map: map,
          draggable: true
        });
        marker.addListener('dragend', () => {
          this.lat = marker.getPosition().lat()
          this.lng = marker.getPosition().lng()
        });
      })
    }
  }

  procesar() {
    this.viewCtrl.dismiss({lat: this.lat, lng: this.lng});
  }

}



// WEBPACK FOOTER //
// ./src/pages/mapa/mapa.ts